import { useCallback } from "react";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import InnerSpinnerLoading from "../../Common/InnerSpinnerLoading/InnerSpinnerLoading";
import CustomTooltip from "../../CustomTooltip";
import DownloadFilesComponent from "../../Common/DownloadFilesComponent/DownloadFilesComponent";
import myDateFormat from "../../../helpers/utils/myDateFormat";
import { deleteMovimentazioneEvent } from "../../../api";
import {
  DeleteIcon,
  InputCircleIcon,
  OutputCircleIcon,
} from "../../../assets/icons";
import userHasPermission from "../../../helpers/formTools/userHasPermission";
import { useAppContext } from "../../Context/AppContext";
import { getDataTableCustomStyles } from "../../../helpers/dataTableThemeStyles";
import "./MovimentazioneEventTable.scss";

const customStyles = getDataTableCustomStyles();

const renderEventTipo = (tipo) => {
  const normalized = tipo?.toLowerCase();
  const isIncoming = normalized === "entrata" || normalized === "ingresso";
  const isOutgoing = normalized === "uscita";
  const tooltip = isOutgoing ? "Uscita" : isIncoming ? "Entrata" : tipo;
  const Icon = isOutgoing
    ? OutputCircleIcon
    : isIncoming
      ? InputCircleIcon
      : null;

  return (
    <div className="event-tipo-cell">
      {Icon && (
        <CustomTooltip text={tooltip}>
          <span className="event-tipo-icon" aria-hidden="true">
            <Icon height="22px" width="22px" fillColor="var(--archeo-color)" />
          </span>
        </CustomTooltip>
      )}
      <span className="event-tipo-label">{tipo}</span>
    </div>
  );
};

const MovimentazioneEventTable = ({
  movimentazioneEvents,
  isLoading,
  totalRows,
  disabled = true,
  handlePerRowsChange,
  handlePageChange,
  handleSort,
}) => {
  const { userProfile } = useAppContext();
  const organization = JSON.parse(localStorage.getItem("organization"));

  const userCanDeleteMovimentazioneEvent = userHasPermission({
    userProfile,
    organization,
    resource: "MOVIMENTAZIONE",
    permission: "DELETE",
  });
  const removeMovimentazioneEvent = useCallback(async (id) => {
    try {
      await deleteMovimentazioneEvent(id);
      toast.success("Data deleted successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 20);
    } catch (error) {
      toast.error("Error deleting data");
    }
  }, []);

  const columns = [
    // {
    //   selector: (row) => row.id,
    //   cell: (row) => (
    //     <div className="table-actions">
    //       <CustomTooltip text={"Browse Event"}>
    //         <button onClick={() => handleMovimentazioneView(row.id)}>
    //           <PdfIcon />
    //         </button>
    //       </CustomTooltip>
    //     </div>
    //   ),
    //   width: "70px",
    //   style: {
    //     padding: "6px",
    //   },
    // },

    {
      name: "",
      selector: (row) => row.id,
      cell: (row) => (
        !disabled && userCanDeleteMovimentazioneEvent ? (
          <div className="table-actions">
            <button onClick={() => removeMovimentazioneEvent(row.id)}>
              <DeleteIcon fillColor="var(--archeo-color)" />
            </button>
          </div>
        ) : null
      ),
      width: "40px",
      style: {
        padding: "6px",
      },
    },
    {
      name: "Tipo",
      selector: (row) => row.tipo,
      cell: (row) => renderEventTipo(row.tipo),
      sortable: true,
      sortField: "tipo",
      width: "150px",
    },
    {
      name: "Data",
      selector: (row) => row.data,
      cell: (row) => myDateFormat(row.data),
      sortable: true,
      width: "200px",
    },
    {
      name: "Allegati",
      selector: (row) => row.allegati,
      //cell: (row) => row.allegati.map((allegato) => <a href={allegato.id} target="_blank" rel="noopener noreferrer">{allegato.name}</a>),
      cell: (row) =>  <DownloadFilesComponent
          fileData={row?.allegati}
          acceptType=".pdf, .jpg, .png"
          disabled={false}
          onChange={() => {}}
        />
    },
  ];
  return (
    <div className="movimentazione-section-table">
      <DataTable
        columns={columns}
        data={movimentazioneEvents}
        progressPending={isLoading}
        progressComponent={<InnerSpinnerLoading isLoading={isLoading} />}
        customStyles={customStyles}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
      />
    </div>
  );
};

export default MovimentazioneEventTable;
